<main class="onb onb--sheet">

  <header class="onb__head">
    <p class="belturo-eyebrow onb__head-eyebrow" data-id="eyebrow"><%= _lcs( 'Konto' ) %></p>
    <h1 class="onb__head-title" data-id="title"><%= _lcs( 'Einen Moment …' ) %></h1>
    <p class="onb__head-sub" data-id="sub"><%= _lcs( 'Wir prüfen deinen Bestätigungslink.' ) %></p>
  </header>

  <div class="onb__scroll onb__done">
    <span class="onb-done__icon" data-id="icon"><i class="icon icon--mail"></i></span>
    <p class="onb-done__lead" data-id="lead"><%= _lcs( 'Das dauert nur einen Augenblick.' ) %></p>
  </div>

  <footer class="onb__foot onb__foot--bordered onb__foot--form" data-id="actions" hidden>
    <button class="btn btn--primary btn--lg btn--block" type="button" data-id="to-login"><%= _lcs( 'Zur Anmeldung' ) %></button>
    <button class="btn btn--secondary btn--lg btn--block" type="button" data-id="guest"><%= _lcs( 'Erstmal ohne Konto ansehen' ) %></button>
  </footer>

</main>
